import { render, staticRenderFns } from "./ClaimStagingAttachs.vue?vue&type=template&id=2909b347&"
import script from "./ClaimStagingAttachs.vue?vue&type=script&lang=js&"
export * from "./ClaimStagingAttachs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClaimStagingAttachs.vue"
export default component.exports